import { render, staticRenderFns } from "./shopAddr.vue?vue&type=template&id=77b448be&scoped=true"
import script from "./shopAddr.vue?vue&type=script&lang=js"
export * from "./shopAddr.vue?vue&type=script&lang=js"
import style0 from "./shopAddr.vue?vue&type=style&index=0&id=77b448be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b448be",
  null
  
)

export default component.exports